import { z } from 'zod';

export const updateQuoteMetadataSchema = z.object({
  name: z.string().min(1).optional(),
  notes: z.string().nullable().optional(),
  vendorId: z.string().uuid().nullable().optional(),
});

export type UpdateQuoteMetadataInput = z.infer<typeof updateQuoteMetadataSchema>;
